export const minimumTipAmount = 2;
export const maximumTipAmount = 100;

/** USD input is explicit decimal money, never rounded from a sub-cent value. */
export function parseTipAmount(raw: string): number | null {
  const value = raw.trim();
  if (!/^\d+(?:\.\d{1,2})?$/.test(value)) return null;
  const amount = Number(value);
  return Number.isFinite(amount) && amount >= minimumTipAmount && amount <= maximumTipAmount ? amount : null;
}

export function isAcceptedTipAmount(amount: number): boolean {
  return Number.isFinite(amount) && parseTipAmount(String(amount)) === amount;
}
